// import { useQuery } from '@tanstack/react-query';
// // import { fetchData } from '../../assets/api/UseStudentGetApi';
// import { fetchData as fetchDataNode } from '../../assets/nodeApi/fetchData';


// const fetchAllApartments = async ( filters ) => {
//   let currentPage = 1;
//   let allData = [];
//   let hasMore = true;

//   while (hasMore) {
//     const res = await fetchDataNode(`collab-apartment-details-list?page=${currentPage}`, filters);
//     const pageData = res?.data?.data || [];
//     allData = allData.concat(pageData);

//     const { current_page, last_page } = res?.data || {};
//     hasMore = current_page < last_page;
//     currentPage += 1;
//   }

//   return allData;
// };


// export const useAllApartmentss = (filters) => {
//   return useQuery({
//     queryKey: ['all-collab-apartment-details', filters],
//     queryFn: () => fetchAllApartments(filters),
//   });
// };


// // export const useAllApartmentss = (filters) => {
// //   return useQuery({
// //     queryKey: ['all-collab-apartment-details', filters],
// //     queryFn: fetchAllApartments(filters),
// //   });
// // };


import { useQuery } from '@tanstack/react-query';
import { fetchData as fetchDataNode } from '../../assets/nodeApi/fetchData';

const fetchAllApartments = async (filters = {}) => {
  let currentPage = 1;
  let lastPage = 1;
  let allData = [];

  do {
    const res = await fetchDataNode(
      `collab-apartment-details-list?page=${currentPage}`,
      filters
    );

    const paginationData = res?.data || {};

    const apiData = paginationData?.data;

    if (!apiData) {
      console.warn('No apiData found', res);
      break;
    }

    // ✅ SAFELY get records
    const records = Array.isArray(apiData)
      ? apiData
      : [];

    if (records.length === 0) {
      break;
    }

    allData.push(...records);

    currentPage = paginationData.current_page
      ? paginationData.current_page + 1
      : currentPage + 1;

    lastPage = paginationData.last_page || currentPage;

  } while (currentPage <= lastPage);

  return allData;
};


export const useAllApartmentss = (filters) => {
  return useQuery({
    queryKey: ['all-collab-apartment-details', filters],
    queryFn: () => fetchAllApartments(filters),
    staleTime: 5 * 60 * 1000, // optional
  });
};

